import React from 'react';
import { BaasicAsyncSelectTemplate } from 'themes/components';

function BaasicAsyncSelect(props) {
	return <BaasicAsyncSelectTemplate {...props} />;
}

export default BaasicAsyncSelect;



// WEBPACK FOOTER //
// ./src/core/components/select/BaasicAsyncSelect.jsx